import { Mail } from "./utils/mail";

window.onload = () => {

  // Send Mail
  // ReCAPTCHA V3
  // clé de site
  // 6LejtC4lAAAAAImZJaoQfxbqnudZpfzW3k3ZwIqt
  // clé secrète
  // 6LejtC4lAAAAAHC-D6dOlrIWb4AFKZy7vNbisXbJ
  // let mail = new Mail("mail_form", "submit_mail");
  // console.log("Valid", mail.sendMail());
  new Mail("mail_form", "submit_mail");
};

